import { render } from "./ItemVe.vue?vue&type=template&id=531486a8&scoped=true"
import script from "./ItemVe.vue?vue&type=script&lang=js"
export * from "./ItemVe.vue?vue&type=script&lang=js"

import "./ItemVe.vue?vue&type=style&index=0&id=531486a8&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531486a8"]])

export default __exports__